import * as domHelpers from "../../scripts/utils/domHelpers.js";
import { quantityInputWrap } from "../../scripts/utils/quantityInputWrap.js";

class ChooseSeats {
    constructor() {
        $(".PriceBand.Info").first().text("Type");

        this.wrapHeader();
        this.handleTicketControls();
    }

    handleTicketControls() {
        const ticketControls = document.querySelectorAll(
            ".Unreserved .TicketType",
        );

        ticketControls.forEach((ticketControl) => {
            const input = ticketControl.querySelector("input");

            const quantityInput = quantityInputWrap(input);

            // Move the quantity input to the end of the ticket control
            ticketControl.appendChild(quantityInput);

            const labels = ticketControl.querySelectorAll("label, span");

            domHelpers.wrapAll(labels, {
                element: "div",
                className: "TicketType_Label",
            });
        });
    }

    wrapHeader() {
        const allElements = Array.from(
            document.querySelectorAll(".SpektrixPage > *"),
        );

        const index = allElements.findIndex((element) =>
            element.classList.contains("AreaAndVenueDetails"),
        );

        if (index === -1) {
            return;
        }

        const headerElements = allElements.slice(0, index + 1);

        domHelpers.wrapAll(headerElements, {
            element: "div",
            className: "spektrix-page-header",
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(".SpektrixPage.ChooseSeats");

    if (pageSelector) {
        new ChooseSeats();
    }
});
